var _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.43359,
    y: 0.522461,
    width: 19.9956,
    height: 19.9958,
    rx: 9.9978,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.43359,
    y: 0.522461,
    width: 19.9956,
    height: 19.9958,
    rx: 9.9978,
    fill: "url(#pattern0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.43359,
    y: 0.522461,
    width: 19.9956,
    height: 19.9958,
    rx: 9.9978,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_221_4707",
    transform: "scale(0.0156252)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_221_4707",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStcIcon);
export default __webpack_public_path__ + "static/media/stcIcon.3f96ebd5dfe5708bc9b7b393f72aefa7.svg";
export { ForwardRef as ReactComponent };